import React from 'react'; 
import {Grid} from '@material-ui/core'; 
import { style } from './style';  
import { withStyles } from '@material-ui/core/styles'; 
import { translate } from 'react-i18next'; 
import { connect } from 'react-redux';
 
class Payment extends React.Component {
     constructor(props) {
        super(props);
        this.state = {   
        }  
    }
    componentDidMount() {  
    } 
    render() {
        const { classes,t, row } = this.props;
        return (
            <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>    
                    <Grid item xs={12 } sm={12}>
                        {t('service_account_add_payment_note')} :  {row.note}
                    </Grid>
                </Grid>
            </form>
        );
    }
}

const mapState = state => ({   
});

const mapDispatch = dispatch => ({   
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(style, { withTheme: true })(Payment))); 